<template>
  <select class="select" @change="onSelect">
    <option
      v-for="item in options"
      :key="item.value"
      :value="item.value"
      class="select__item"
      :selected="item.selected"
      >{{ item.text }}</option
    >
  </select>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSelect(e) {
      this.$emit("handleSelect", e.target.value);
    }
  }
};
</script>

<style scoped>
.select {
  margin: 0px;
  width: auto;
  height: 40px;
  padding: 10px 20px;
  font-size: 15px;
  color: #222c44;
  text-align: center;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  outline: none;
}

.select > option {
  color: #000000;
  background-color: #ffffff;
}
</style>
